import { storageKey } from "@/constants";
import { Store } from "./store";
import { createJSONStorage, persist } from "zustand/middleware";
import { WecomContactType } from "@packages/chat-sdk";

export interface WecomChatPersistentStoreType {
  chatId?: string;
  chatType?: WecomContactType;
}
export const wecomChatPersistentStore = new Store<WecomChatPersistentStoreType>(
  persist(
    () => ({
      chatId: undefined,
      chatType: undefined,
    }),
    {
      name: storageKey.WECOM_CHAT_STORAGE, // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    }
  ) as any
);

export const wecomChatPersistentStoreActions = {
  selectConversation(payload: {
    chatId?: string;
    chatType?: WecomContactType;
  }) {
    wecomChatPersistentStore.set(payload);
  },
  reset() {
    localStorage.removeItem(storageKey.WECOM_CHAT_STORAGE);
  },
};
